export enum PartnersEnum {
	zesty = 'Zesty',
	globaldots = 'Globaldots',
	renova = 'Renova Cloud',
	commit = 'Comm-IT',
	cloudreach = 'Cloudreach',
	allcloud = 'AllCloud',
	cbts = 'CBTS',
	ingrammicro = 'IngramMicro',
	hitachivantara = 'Hitachi Vantara',
	midlink = 'MidLink',
	fxinnovation = 'FX Innovation',
	plusserver = 'PlusServer',
	nops = 'nOps',
	cloudadvisorsinc = 'Cloud Advisors Inc',
	oakrocket = 'OakRocket',
	'2bcloud' = '2bcloud',
	enkel = 'Enkel',
	simoda = 'Simoda',
	ackstorm = 'ackstorm',
	dtcs = 'dtcs',
	ibexlabs = 'ibexlabs',
	chinamobile = 'Chinamobile International Limited',
	skypurple = 'SkyPurple',
	hykell = 'Hykell',
	flexa = 'Flexa',
	trustsoft = 'Trustsoft',
	alphaus = 'Alphaus',
	cloudride = 'Cloudride',
	kloia = 'Kloia',
	pax8 = 'Pax8',
	atlas7 = 'Atlas7',
	revolgy = 'Revolgy',
	directeam = 'Directeam',
	cloudlife = 'Cloudlife',
	ixperf = 'Infrastructure Performance',
	acecloud = 'Ace Cloud',
	playgroundtech = 'Playgroundtech',
	terasky = 'TeraSky',
	convergetp = 'Convergetp',
	dcsolution = 'DCSolution',
	allcloudus = 'Allcloud US',
	bridgetek = 'Bridgetek',
	acmadv = 'Acmadv',
	dnxbrasil = 'DNXBrasil',
	esxtech = 'ESXTech',
	dmoove = 'Dmoove',
	wangsu = 'Wangsu',
	datacomau = 'Datacomau',
	partnertest = 'PartnerTest',
	v8tech = 'v8tech',
	redapt = 'Redapt',
	alignedtg = 'Aligned Technology Group',
}
